import { render, staticRenderFns } from "./listEmails.vue?vue&type=template&id=2b1d74a6"
import script from "./listEmails.vue?vue&type=script&lang=js"
export * from "./listEmails.vue?vue&type=script&lang=js"
import style0 from "./listEmails.vue?vue&type=style&index=0&id=2b1d74a6&prod&lang=css"
import style1 from "./listEmails.vue?vue&type=style&index=1&id=2b1d74a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports